import React, { memo } from 'react';
import IconMC from '../../../components/IconMC';

/**
 * 🧬 Molécula: OrderNoteActionsMC
 * Renderiza las acciones de la orden (PDF, link, enviar por plataforma).
 */

const OrderNoteActionsItemMC = memo(
  ({
    onClick,
    iconName,
    labelLines,
    size = '5xl',
    iconClassName = 'tw-text-[#3CAAE1]',
    bgClass = 'tw-bg-[#EBF7FC]',
    sizeClass = 'tw-w-[48px] tw-h-[48px]'
  }) => (
    <div className="tw-flex tw-flex-col tw-items-center">
      <span className="tw-cursor-pointer" onClick={onClick}>
        <div
          className={`tw-flex tw-items-center tw-justify-center tw-rounded-full ${sizeClass} ${bgClass}`}
        >
          <IconMC name={iconName} size={size} className={iconClassName} />
        </div>
      </span>
      {labelLines.map((line, idx) => (
        <span key={idx} className={idx === 0 ? 'tw-mt-1 tw-text-center' : 'tw-text-center'}>
          {line}
        </span>
      ))}
    </div>
  )
);

OrderNoteActionsItemMC.displayName = 'OrderNoteActionsItemMC';
export default OrderNoteActionsItemMC;
